import type { ReactNode } from 'react';

import type { Message } from '../../state';
import ConversationBranchControl from '../ConversationBranchControl';
import EditLastQueryForm from '../EditLastQueryForm';
import MessageEditButton from '../MessageEditButton';
import useStyles, { USER_ACTIONS_CLASS } from './MessageBubble.styles';
import type { UserMessageControls } from './types';

type UserMessageTurnProps = {
  message: Message;
  ariaLabel: string;
  copyButton: ReactNode;
  controls?: UserMessageControls;
};

/** User query bubble or its inline branch-edit form. */
function UserMessageTurn({
  message,
  ariaLabel,
  copyButton,
  controls,
}: UserMessageTurnProps) {
  const { classes, cx } = useStyles();

  if (controls?.isEditing === true) {
    return (
      <div className={cx(classes.userStack, classes.userStackEditing)}>
        <EditLastQueryForm
          messageId={message.id}
          initialValue={message.content}
          isSubmitting={controls.isCreatingBranch}
          isSubmitDisabled={controls.isBusy}
          onCancel={controls.onCancelEdit}
          onSubmit={controls.onSubmitEdit}
        />
      </div>
    );
  }

  const hasActions = copyButton !== null || controls !== undefined;
  const actionsArePersistent =
    controls?.branchNavigation !== undefined &&
    controls.branchNavigation !== null;

  return (
    <div className={classes.userStack}>
      <article
        className={cx(classes.bubble, classes.bubbleUser)}
        aria-label={ariaLabel}
      >
        {message.content}
      </article>
      {hasActions ? (
        <div
          className={cx(
            classes.userActions,
            USER_ACTIONS_CLASS,
            actionsArePersistent && classes.userActionsPersistent
          )}
        >
          {copyButton}
          {controls ? (
            <MessageEditButton
              disabled={controls.isBusy}
              onClick={controls.onEdit}
              testId={`ai-sidekick-edit-${message.id}`}
            />
          ) : null}
          {controls?.branchNavigation ? (
            <ConversationBranchControl
              navigation={controls.branchNavigation}
              disabled={controls.isBusy}
              onSwitch={controls.onSwitchBranch}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default UserMessageTurn;
